import { useRef } from 'react';
import { TransitionGroup } from 'react-transition-group';
import { SizeTransition } from '@utils/react';
import { Task } from '../components/organism.task/_task.js';
import { TaskContext } from '../components/organism.task/context.js';
import { TaskContainerContext } from '../components/organism.task/hook.task-breakpoints.js';
import { TaskHeader } from '../components/organism.task/molecule.task-header/_task-header.js';
import { PageContext } from '../context.js';
import { useOpgavekompleksetComponent } from '../state/context.data.js';
import { useCurrentTask } from '../state/hook.current-task.js';
import { useCurrentTaskEntry } from '../state/hook.entry.js';
import { makeSelectTaskState } from '../state/selectors/task.get-state.js';
import { container, contentWrapper, content, crossfadeDurationMs } from './_page.input.style.js';
import { jsx, jsxs } from 'react/jsx-runtime';
import { TaskFooter } from './molecule.footer/_task-footer.js';

function InputPage(props) {
  const component = useOpgavekompleksetComponent();
  const {
    task,
    index
  } = useCurrentTask();
  const ref = useRef(null);
  const taskState = useCurrentTaskEntry({
    select: makeSelectTaskState(component.data)
  }) ?? "input";
  if (!task) {
    return null;
  }
  return /*#__PURE__*/jsx(TaskContainerContext.Provider, {
    value: ref,
    children: /*#__PURE__*/jsx(PageContext.Provider, {
      value: "input",
      children: /*#__PURE__*/jsxs("section", {
        ref: ref,
        className: container,
        children: [/*#__PURE__*/jsx(TaskHeader, {
          ...props,
          rootRef: ref,
          type: "input-page",
          task: task,
          taskIndex: index
        }), /*#__PURE__*/jsx("div", {
          className: contentWrapper,
          "data-focus-content": true,
          tabIndex: -1,
          children: /*#__PURE__*/jsx(TransitionGroup, {
            component: null,
            children: /*#__PURE__*/jsx(SizeTransition, {
              axis: "vertical",
              swappable: true,
              timeout: crossfadeDurationMs,
              classNames: content,
              delayMs: {
                enter: 10,
                exit: 10
              },
              children: ref => /*#__PURE__*/jsx(TaskContext.Provider, {
                value: taskState,
                children: /*#__PURE__*/jsx(Task, {
                  ref: ref,
                  className: content,
                  task: task,
                  taskIndex: index
                })
              })
            }, `${taskState}-${task.id}`)
          })
        }), /*#__PURE__*/jsx(TaskFooter, {
          rootRef: ref,
          task: task,
          taskIndex: index
        })]
      })
    })
  });
}

export { InputPage };
//# sourceMappingURL=_page.input.js.map
